import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Button } from '@vio/atlas/Button';
import { Icon } from '@vio/atlas/Icon';
import { toggle } from 'opticks';
import { isApple } from '@daedalus/core/src/_web/utils/userAgent';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity, Team } from '@daedalus/core/src/analytics/types/Events';
import { getOnAuthSuccessLandingUrl } from '@daedalus/core/src/auth/business/persistData';
import { TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY } from '@daedalus/core/src/auth/modules/actions';
import { getAuthenticationFlow, getSusiAnalyticsData } from '@daedalus/core/src/auth/modules/selectors';
import { AuthenticationFlows, AuthenticationMethod } from '@daedalus/core/src/auth/types/Auth';
import { AuthenticationProvider } from '@daedalus/core/src/auth/types/Cognito';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { HandleLogin } from '../types';
const ButtonsWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonsWrapper",
  class: "b180ti5k",
  propsAsIs: false
});
interface Props {
  handleLogin: HandleLogin;
  handleEmailLogin?: (e: React.SyntheticEvent) => void;
  handleOnClose?: () => void;
}
export const SignInButtons = ({
  handleLogin,
  handleEmailLogin,
  handleOnClose
}: Props) => {
  const dispatch = useDispatch();
  const analyticsData = useSelector(getSusiAnalyticsData);
  const isAppleDevice = isApple();
  const successLandingUrl = getOnAuthSuccessLandingUrl();
  const authenticationFlow = useSelector(getAuthenticationFlow);
  const isPreCheckout = authenticationFlow === AuthenticationFlows.PreCheckout;

  // added as part of 567c4139-signin-to-complete-booking
  const handleContinueAsGuest = useCallback(() => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.SkipAuthentication,
      action: Action.Clicked,
      team: Team.Retention,
      payload: {
        authenticationFlow: AuthenticationFlows.PreCheckout
      }
    }));

    // If we don't have a success landing URL, simply close the sheet
    if (!successLandingUrl) {
      handleOnClose?.();
      return;
    }

    // Otherwise redirect after giving analytics a chance to track the event
    setTimeout(() => {
      window.location.href = successLandingUrl;
    }, TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY);
  }, [dispatch, successLandingUrl, handleOnClose]);
  return <ButtonsWrapper>
      {isAppleDevice && <Button fullWidth dataId="SocialLoginApple" size="xl" iconStart={<Icon name="Apple" />} variant="secondary" onClick={handleLogin(AuthenticationMethod.Apple, AuthenticationProvider.Apple, analyticsData)}>
          <FormattedMessageWrapper id="SUSI.continueWith" defaultMessage="Continue with {channel}" values={{
        channel: 'Apple'
      }} />
        </Button>}

      <Button fullWidth variant="secondary" dataId="SocialLoginGoogle" size="xl" iconStart={<Icon name="GoogleColor" />} onClick={handleLogin(AuthenticationMethod.Google, AuthenticationProvider.Google, analyticsData)}>
        <FormattedMessageWrapper id="SUSI.continueWith" defaultMessage="Continue with {channel}" values={{
        channel: 'Google'
      }} />
      </Button>

      <Button fullWidth variant="secondary" dataId="SocialLoginFacebook" size="xl" iconStart={<Icon name="FacebookColor" />} onClick={handleLogin(AuthenticationMethod.Facebook, AuthenticationProvider.Facebook, analyticsData)}>
        <FormattedMessageWrapper id="SUSI.continueWith" defaultMessage="Continue with {channel}" values={{
        channel: 'Facebook'
      }} />
      </Button>
      {toggle('367a6300-email-otp-signup', false, <Button fullWidth variant="secondary" dataId="SocialLoginEmail" size="xl" iconStart={<Icon name="Mail" />} onClick={handleEmailLogin}>
          <FormattedMessageWrapper id="SUSI.continueWith" defaultMessage="Continue with {channel}" values={{
        channel: 'Email'
      }} />
        </Button>)}

      {isPreCheckout && toggle('567c4139-signin-to-complete-booking', false, <Button fullWidth variant="quiet" dataId="ContinueAsGuest" size="xl" onClick={handleContinueAsGuest}>
            <FormattedMessageWrapper id="SUSI.continueAsGuest" defaultMessage="Continue as guest" />
          </Button>)}
    </ButtonsWrapper>;
};

require("./SignInButtons.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SignInButtons.tsx");